import React from 'react';
import WidgetLoader from '../../src/admin/modules/pageBuilder/components/WidgetLoader';

// TODO: If/when we refactor page editing to use the new v2 API
// we'll want to return to this container and make it work with widget/section moving.
// Alternatively, we can make page and layout editing two separate concepts code-wise so
// widget/section-specific code isn't living with page layout editing code.
export default props => <WidgetLoader {...props} />;
